import { Image, Stack, Text, useColorModeValue } from "@chakra-ui/react";
import { FiLoader } from "react-icons/fi";
import { photoBaseURL } from "../../../service/api";
import http, { AUTH_ROUTES } from "../../../service/api";
import { useState } from "react";
import { useEffect } from "react";
import useSmallScreen from "../../../components/useSmallScreen";
import thelogo from "../../../assets/thelogo.png"

function NotificationModal({ open, setOpenNotification }) {
  const bgColor = useColorModeValue("#fff", "#000216");
  const textColor = useColorModeValue("#294566", "#FFECEC");
  const [smallScreen] = useSmallScreen();
  const [loading, setLoading] = useState(true);
  const [notifications, setNotifications] = useState([]);

  //get notification on open
  useEffect(() => {
    if (!open) return;
    setLoading(true);
    http
      .get(AUTH_ROUTES.GET_NOTIFICATIONS)
      .then(({ data }) => {
        setNotifications(data?.data);
        console.log("noti: ", data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, [open]);

  const style = {
    position: "fixed",
    right: smallScreen ? "0" : "20px",
    borderRadius: "20px",
    padding: "10px 15px 10px 25px",
    boxShadow: "2px 13px 15px #00000033",
    top: "60px",
    background: bgColor,
    color: textColor,
    height: "300px",
    width: "400px",
    fontWeight: "light",
  };

  return (
    open && (
      <Stack {...style}>
        <Stack
          className="scroll-container"
          spacing={"20px"}
          pr="10px"
          h="300px"
          justifyContent={loading ? "center" : "normal"}
        >
          {loading ? (
            <FiLoader style={{ alignSelf: "center" }} />
          ) : (
            notifications?.map((notification) => {
              const type = notification?.data?.tag;
              return (
                <Stack direction={"row"} alignItems="center">
                  <Image
                    w="40px"
                    h="40px"
                    borderRadius="50%"
                    fallbackSrc={thelogo}
                    src={notification?.data?.user?.picture}
                    alt="user photo"
                  />
                  <Stack spacing={"0.5"}>
                    <Text fontWeight={"bold"} color={textColor}>
                      @{notification?.data?.user?.username}
                    </Text>
                    <Text
                      fontSize={".8em"}
                      color={
                        type === "new.follower"
                          ? "#4B41F1"
                          : type === "new_member"
                          ? "#F1415E"
                          : ""
                      }
                    >
                      {type === "new.follower"
                        ? "Started following you"
                        : type === "new.group.member"
                        ? "Just joined your group"
                        : ""}
                    </Text>
                  </Stack>
                </Stack>
              );
            })
          )}
        </Stack>
      </Stack>
    )
  );
}

export default NotificationModal;
